import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { HttpService, NotificationService, TmsWebBaseEditCreateService } from 'tms-lib';
import { PurchaseOrderLineRequirement } from '../../../models';

@Injectable({
  providedIn: 'root',
})
export class PurchaseOrderLineRequirementService extends TmsWebBaseEditCreateService<
  PurchaseOrderLineRequirement,
  PurchaseOrderLineRequirement
> {
  public refreshDetails = new Subject<void>();

  constructor(protected httpService: HttpService, protected notificationService: NotificationService) {
    super('PurchaseOrderLineRequirement', $localize`Purchase Order Line Requirement`, httpService, notificationService);
  }

  createPurchaseOrderRequirements(
    purchaseOrderLineId: string,
    purchaseOrderLineRequirementId,
  ): Observable<PurchaseOrderLineRequirement[]> {
    return this.httpService.get<PurchaseOrderLineRequirement[]>(
      `${this.apiUrl}/CreatePurchaseOrderRequirements/${purchaseOrderLineId}${
        purchaseOrderLineRequirementId ? `/${purchaseOrderLineRequirementId}` : ''
      }`,
    );
  }

  updateRequirements(purchaseOrderLineId: string, quantity: number): Observable<any> {
    return this.httpService.post<any>(`${this.apiUrl}/UpdateRequirements`, {
      purchaseOrderLineId,
      quantity,
    });
  }
}
